import { http } from '@/lib/http'
import { ORDER_PAYMENT_PROVIDERS } from '@/features/subscription/subscription.api'
import type { AgreementPaymentInit, PaymentConfirmStatus, PaymentValidateResult } from '@/types/models'

export const agreementPaymentApi = {
  initiate: (agreementId: string, hardCopyRequested: boolean) => http.post<AgreementPaymentInit>(`/agreements/${agreementId}/payment`, { hardCopyRequested, paymentProviders: ORDER_PAYMENT_PROVIDERS }),
  status: (agreementId: string) => http.get<PaymentConfirmStatus & { agreementId: string; agreementStatus: string }>(`/agreements/${agreementId}/payment-status`),
  validate: (agreementId: string) => http.get<PaymentValidateResult & { agreementId: string; agreementStatus: string }>(`/agreements/${agreementId}/payment-validate`),
  cancel: (agreementId: string, paymentToken: string) => http.delete<null>(`/agreements/${agreementId}/payment`, { data: { paymentToken } }),
}
